<template>
    <div class="about-sw" style="/*display: table-cell;*/vertical-align: middle;text-align: center;">
        <!-- ============= 顶部背景图 ============= -->
        <div style=' margin: 0px auto;background: rgba(0, 0, 0, 0) url("web/bk/bk1.png") repeat scroll 0% 0% / 100%;'>
            <img src="../../assets/images/about/banner.png" style="height: 505px; width: 1300px;display: block;margin: 0px auto;">
        </div>

        <!-- ============= 企业简介 ============= -->
        <div class="about-message" style="display: inline-block;width: 1200px;text-align: left">
            <div style="font-size: 36px"><h1 style="text-align: center;font-size: 36px;">About Us</h1></div>
            <div>
                <div style="float: right">
                    <img src="../../assets/images/about/tp.png">
                </div>
                <div style="white-space: pre-wrap;text-indent: 35px;line-height: 27px;">
            SINO WEALTH ELECTRONIC LTD. was established in July 1994 and was listed on the Shenzhen Stock Exchange Growth Enterprise Market in 2012 (stock code: 300327). The company's primary business is the design and sale of self-branded semiconductor chips, along with providing corresponding system solutions and technical support services. 
            Its main product lines include MCU (Microcontroller Unit chips for industrial control), BMIC (Lithium Battery Management chips), and AMOLED (Active Matrix Organic Light-Emitting Diode display driver chips). The MCU microcontroller systems are primarily used in household appliances, motor control, smart meters, and the Internet of Things (IoT) sector. BMIC chips are designed for lithium battery measurement and protection, while AMOLED display driver chips are used in smartphones and wearable products. Vehicle  MCU is mainly used in fields such as electronic universal control of automotive body and motor control.
            The company is recognized as a high-tech enterprise, a Shanghai Enterprise Technology Center, and a Shanghai-based privately-owned headquarters enterprise. It has received honors such as the Shanghai Patent Work Pilot Demonstration Unit and the Shanghai Intellectual Property Advantage Enterprise.
            SINO WEALTH ELECTRONIC LTD. adheres to the corporate spirit of "Diligence in Heart, Excellence in Technology," and pursues endless innovation. It strives to meet the demands of international clients with top-notch product quality and service, builds cooperative partnerships through honest business practices, earns the trust of its customers, and achieves global competitiveness.

                </div>
                <div style="text-indent: 35px;line-height: 27px;">
                Sales(Mainland):<a href="mailto:sales.sh@sinowealth.com" class="blue12px">sales.sh@sinowealth.com</a><br>
                Sales(Overseas):<a href="mailto:sales.hk@sinowealth.com.hk" class="blue12px">sales.hk@sinowealth.com.hk</a><br>
                HR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:<a href="mailto:HR@sinowealth.com" class="blue12px">HR@sinowealth.com </a><br>
                IR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:<a href="mailto:IR@sinowealth.com" class="blue12px">IR@sinowealth.com</a><br>
                </div>
            </div>
            <!--div style="height: 420px">
                <div style="float: left">
                    <img src="../../assets/images/about/tp.png">
                </div>

                <div style="float: left;text-align: left;margin-left: 80px">
                    <h2>中颖电子</h2>
                    <p style="color:rgba(153,153,153,1);">SinoWealth</p>
                    <h2 >国产化锂电控制芯片中国市场的领先者</h2>
                    <p style="width: 560px;height: 180px;color:rgba(51,51,51,1);">中颖电子股份有限公司(股票编号SZ300327)是一家专注于单片机集成电路设计与销售的高新公司，
                      是首批被中国工业及信息化部及上海市信息化办公室认定的集成电路设计企业，并连续数年被评定为“上海市高新技术企业”。</p>
                </div>
              <img src="../../assets/images/about/weizhankai.png" style="margin-top: 20px" @click="mores()" v-if="!moreShow">
            </div>


            <div  style="display: inline-block;text-align: left;height: 280px" v-if="moreShow">
                <div style="font-size: 36px"><h2 style="text-align: left;font-size: 24px;">白色家电控制芯片中华区厂商排名第一</h2></div>
                <p  style="width: 1280px;height: 220px;color:rgba(51,51,51,1);width: 1000px">中颖电子本着专业专精的精神,专注于于单片机(MCU)产品集成电路设计.
                    MCU母体包括8-bit Flash MCU、8-bit OTP/Mask MCU、16-bit DSP、4-bit OTP/Mask MCU,并广泛应用于家电、白色家电、黑色家电、汽车电子周边、运动器材、
                    医疗保健四表（水、电、气、暖）、仪器仪表、安防、电源控制、马达控制、工业控制、变频、数码电机、计算机键盘、鼠标、网络音乐（便携式、车载、床头音响）、无线儿童监控器、
                    无线耳机/喇叭/门铃. 中颖电子经过多年努力,结合MCU的开发经验,采用高压制程,开拓了锂电池管理和保护产品线.产品广泛应用于笔记本电脑、智能手机、平板电脑、电动工具、
                    电动自行车、UPS和移动基站等领域的锂电池管理和保护.同时,还扩充了OLED系列产品,以环保节能 的先进理念揭开新的篇章</p>
            </div>

            <div style="height: 420px;width: 1200px;" v-if="moreShow">
                <div style="float: left;display: inline-block">
                    <img src="../../assets/images/about/tp2.png">
                </div>
                <div style="float: left;margin-left: 80px;text-align: left">
                    <h2>小家电控制芯片中国市场排名第一</h2>
                    <p style="width: 520px;height: 315px;color:rgba(51,51,51,1);">中颖电子根植中国,贴近市场,贴近客户,坚持专业化、差异化、成本化的经营策略,不断增强自身的核心竞争力及价值,协助终端客户持续降低不良率和返修率,提高生产直通率,建立了良好的质量可靠度形象.相信在既有团队的努力及产能的充分支持下,必能支持您大幅提升竞争力,同时我们也将鞭策自己在产品与服务上进一步提升质量,迈入新境界,使客户及我们自己都能在这激烈的竞争中更为突出、领先。</p>
                </div>
            </div>

            <div style="height: 120px;width: 1100px;text-align: left;margin-left: 30px" v-if="moreShow">
                <p style="color:rgba(51,51,51,1);">我们秉承"先有客户的成功,才有我们的成功"的理念,坚持"以客户满意为指标"的宗旨,继续不懈努力,不断创新,为客户提供质量稳定、高一致性、高性价比的产品和高效的服务.我们期待与您更加密切的合作,集合作伙伴之力以达到双赢. </p>
            </div-->

          <img src="../../assets/images/about/shouqi.png" style="margin-top: 20px" @click="mores()" v-if="moreShow">
        </div>
        <!-- ============= 企业文化 ============= -->
        <!--
        <div class="about-culture">
          <div class="about-culture-content">
            <h1 class="about-culture-content-title">企业文化</h1>
            <div style="margin: 0 auto">
              <div class="about-culture-one">
                <p style="margin: 120px auto 40px auto;font-size: 32px;font-weight: 600;">核心价值</p>
                <p>以人为本，专注深耕</p>
                <p>引导全体员工向前奋进的文化底蕴(勤于心，精于技)</p>
              </div>
              <div class="about-culture-two">
                <p style="margin: 120px auto 40px auto;font-size: 32px;font-weight: 600;">经营理念</p>
                <p>无止境的创新，以一流产品质量与服务满足国际化大客户需</p>
                <p>并以诚信经营建构合作伙伴与客户端信赖，成就全球性竞争实力</p>
              </div>
            </div>
          </div>
        </div>
        -->
        <!-- ============= 相关专利 ============= -->
        <!--
        <div class="about-certificate">
            <h1 style="font-size: 36px;" >专利设计</h1>
            <div style="margin-top: 40px">
                <span :class="{titleType:certificate==0}" style="font-size: 22px;cursor: pointer" @click="reload(0)">软件著作权(8)</span>
                <span style="margin-left: 24px">|</span>
                <span :class="{titleType:certificate==1}" style="font-size: 22px;margin-left: 24px;cursor: pointer" @click="reload(1)">专利证书(12)</span>
                <span style="margin-left: 24px">|</span>
                <span :class="{titleType:certificate==2}" style="font-size: 22px;margin-left: 24px;cursor: pointer" @click="reload(2)">其他(18)</span>
            </div>

            <ul class="about-certificate-ul" v-for="item in softwareCopyright" v-if="certificate==0">
                <li><img v-image-preview src="../../assets/images/about/zs.png"></li>
            </ul>

            <ul class="about-certificate-ul" v-for="item in patentCertificate" v-if="certificate==1">
              <li><img v-image-preview src="../../assets/images/about/zs.png"></li>
            </ul>

            <ul class="about-certificate-ul" v-for="item in otherList" v-if="certificate==2">
              <li><img v-image-preview src="../../assets/images/about/zs.png"></li>
            </ul>
        </div>
        -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showMore: false,
                isLongContent: false,
                certificate: 0,
                softwareCopyright: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                patentCertificate: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                otherList: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                moreShow: false // 更多显示
            }
        },

        mounted() {

        },

        watch:{
            content () {
                this.calculateHeight()
            }
        },

        methods: {
            calculateHeight () {
                // $nextTick()，等待内容获取完毕再计算高度，异步处理
                this.$nextTick().then(() => {
                    let contentHeight = this.$refs.content.clientHeight
                    if (contentHeight > this.showHeight) {
                        this.isLongContent = true
                    } else {
                        this.isLongContent = false
                    }
                })
            },

            reload:function (index) {
                this.certificate = index
                // window.location.reload();
            },
            mores() {
                this.moreShow = !this.moreShow
            }
        }
    }
</script>

<style>
  .about-sw .about-culture { height: 666px;background: url("../../assets/images/about/beijingtu.png");background-size: cover;}
  .about-culture-content {width: 68%;margin: 0 auto;padding-top: 60px;}
  .about-culture-content-title {font-size: 48px;color: #ffffff;margin: 0;padding-bottom: 60px;}
  .about-culture .about-culture-one { margin: 0;padding: 0;width: 50%;height: 408px;background: url("../../assets/images/about/hexinjiazhi.png");float: left }
  .about-culture .about-culture-two { margin: 0;padding: 0;width: 50%;height: 408px;background: url("../../assets/images/about/jingyinglinian.png");float: left }
  .about-sw .about-certificate { height: 640px;text-align: center;width: 70%;display: inline-block;overflow:auto; }
  .about-sw .about-certificate > img { margin-left: 120px }
  .about-sw .about-certificate > ul > li { list-style:none;float: left;margin-left: 25px;}
  .about-sw .about-certificate .about-certificate-ul {list-style-type:none;cursor:pointer;margin-top: 60px;width: 1200px;transition:opacity 1s;
    animation:bounce-in 3s;
  }
  @keyframes bounce-in{
    0%{transform:scale(0);}
    100%{transform:scale(1);}
  }
  .about-sw .about-certificate .titleType {color: #4A90E2;}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue